import PropTypes from "prop-types"
import React, { useEffect } from "react"
import ResetPassword from "src/main/Account/Settings/ResetPassword"
import WorkOsUserSecurityPanel from "src/main/Account/Settings/WorkOsUserSecurityPanel"

import { useTracker } from "src/hooks/use_tracker"

const IosLoginAndSecurityWebview = ({
  minimumPasswordLength,
  workosUserSecurityWidgetEnabled,
}) => {
  const tracker = useTracker()

  useEffect(() => {
    tracker.trackEvent(
      "boater_account:ios_login_and_security_webview_screen_viewed"
    )
  }, [tracker])

  return (
    <div className="px-4 py-6">
      {workosUserSecurityWidgetEnabled ? (
        <WorkOsUserSecurityPanel />
      ) : (
        <ResetPassword minimumPasswordLength={minimumPasswordLength} />
      )}
    </div>
  )
}

IosLoginAndSecurityWebview.propTypes = {
  minimumPasswordLength: PropTypes.number.isRequired,
  workosUserSecurityWidgetEnabled: PropTypes.bool.isRequired,
}

export default IosLoginAndSecurityWebview
